<template>
  <div class="my-3 grid grid-cols-12 gap-4 md:my-2">
    <div class="col-span-2 flex justify-center">
      <img
        src="@/assets/highway-badge.svg"
        alt="edge capacity logo"
      />
    </div>
    <div class="col-span-10 flex flex-col justify-start">
      <p class="text-left text-2xs font-bold uppercase text-body-color">
        {{ title }}
      </p>
      <p class="text-left text-1md text-dark-blue">
        {{ subtitle }}
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'InformativeItem',
  props: {
    title: {
      type: String,
      default: '',
    },
    subtitle: {
      type: String,
      default: '',
    },
    image: {
      type: String,
      default: 'yellow-checkmark.svg',
    },
  },
};
</script>
